import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@mantine/core';

type LogoutButtonProps = ButtonProps;

export function LogoutButton(props: LogoutButtonProps) {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Button variant="subtle" color="gray" onClick={handleLogout} {...props}>
      Log out
    </Button>
  );
}
